import { apiV1 } from './api';

export const getMissions = params => apiV1.get('/missions', { params });

export const getMission = missionId => apiV1.get(`/missions/${missionId}`);

export const putMission = (missionId, updatedMission) =>
  apiV1.put(`/missions/${missionId}`, { mission: updatedMission });
